import ContentWrap from './content-wrap';

export default ContentWrap;
